import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    row: {
      '& td': {
        backgroundColor: palette.background.default,
        borderBottom: '0px solid ' + palette.divider,
        padding: '1.2rem 0.5rem',
        maxWidth: 0,

        '&:first-child': {
          width: '130px',
          minWidth: '130px',
          color: 'var(--text-title)',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          paddingLeft: '2rem',
        },
        '&:nth-child(2)': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        '&:nth-child(3)': {
          width: '200px',
          minWidth: '200px',
        },
        '&:nth-child(4)': {
          width: '300px',
          minWidth: '300px',
        },

        '&:last-child': {
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
          width: '50px',
          minWidth: '50px',
        },
      },
    },
  }),
)
